import { render, staticRenderFns } from "./ChatWedget.vue?vue&type=template&id=4ec892cd"
import script from "./ChatWedget.vue?vue&type=script&lang=js"
export * from "./ChatWedget.vue?vue&type=script&lang=js"
import style0 from "./ChatWedget.vue?vue&type=style&index=0&id=4ec892cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports